import React from "react";

const ORIGIN = {DOCUMENT_EXPLICIT:'dichiarati nel documento', DOCUMENT_CONTEXT:'coerenti con il cartiglio', DEFAULT_MM:'predefiniti (regola mm)', USER_CONFIRMED:'confermati dall’utente', USER_MODIFIED:'modificati dall’utente'};

/** Unità delle quote: provenienza sempre visibile (documento / predefinito / utente) e selettore modificabile. Nessuna conferma richiesta per i mm. */
export const UnitsControl=({ctx,code,units,compact=false})=>{
  const u=units||{},val=ctx.dec.unit||'';
  const declared=(u.declarations||[]).map(d=>d.label).join('; ');
  return <div className="qw-units" data-testid={`quote-units-${code}`} data-origin={u.origin||''} data-unit={u.unit||''}>
    {!compact&&<small data-testid={`quote-units-message-${code}`}>{u.message||'Unità: mm predefiniti'}{u.origin==='DEFAULT_MM'&&' · nessuna conferma richiesta'}</small>}
    <label className="qw-units-select">
      <span>Unità{u.origin?` · ${ORIGIN[u.origin]||u.origin}`:''}</span>
      <select data-testid={`quote-units-select-${code}`} value={val} disabled={!ctx.canSave} onChange={e=>ctx.update('unit',e.target.value||null)}>
        <option value="">{u.document_unit?`Dal documento (${u.document_unit==='inch'?'pollici':'mm'})`:'Predefinito (mm)'}</option>
        <option value="mm">mm</option>
        <option value="inch">pollici (×25,4)</option>
      </select>
    </label>
    {u.converted&&<small className="qw-units-warning" data-testid={`quote-units-converted-${code}`}>Documento in pollici: valori letti convertiti ×25,4; geometria vettoriale del PDF non usata.</small>}
    {u.conflict&&<small className="qw-units-warning" data-testid={`quote-units-conflict-${code}`}>Dichiarazioni discordanti nel documento ({(u.declared_units||[]).join(', ')}): verificare sul disegno.</small>}
    {!compact&&declared&&<small data-testid={`quote-units-evidence-${code}`}>Evidenza: {declared}</small>}
  </div>;
};
